// Per-env scheme so prod / staging / dev desktop builds each claim their own
// deeplink and never steal each other's handoff (hypestream / hypestream-staging
// / hypestream-dev). Falls back to the prod scheme when unset.
function getDesktopScheme(): string {
  return import.meta.env.VITE_DESKTOP_SCHEME || "hypestream";
}

// Built in the system browser after login, then opened by the OS to hand the
// session back to the desktop app, which consumes it via supabase.auth.setSession.
export function buildAuthDeepLink(session: {
  access_token: string;
  refresh_token: string;
}): string {
  const params = new URLSearchParams({
    access_token: session.access_token,
    refresh_token: session.refresh_token,
  });
  return `${getDesktopScheme()}://auth#${params.toString()}`;
}

export type CheckoutReturnStatus = "success" | "cancelled";

// Built by the /checkout-return page after a desktop-sourced Stripe Checkout
// (Stripe only accepts http(s) return URLs, so the page bounces to the app).
// Pure UX — payment truth stays with the webhook, exactly like ?checkout=success.
export function buildCheckoutDeepLink(status: CheckoutReturnStatus): string {
  return `${getDesktopScheme()}://checkout#status=${status}`;
}
